import { is } from 'immer/dist/internal'
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import roleList, { selectRoleListData } from '../../features/rolebase/roleList';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
const ModuleRow = ({module,  handleChangeModule,rolePermissions,groupPermissions,roleListData}:
    {module:any, handleChangeModule:any, rolePermissions:any,groupPermissions:any,roleListData:any}) => {
      const RoleList = useAppSelector(selectRoleListData);
   const [modulePermission, setModulePermission]=useState<any>([])

 function getModulePermission (){
  roleListData?.map((modulePermit:any)=>{
    if(module.moduleId===modulePermit.moduleId){
      //console.log(modulePermit?.permission)
      return  (modulePermit?.permission)?setModulePermission(modulePermit?.permission.split(",")):[]
    }
  })
 }


  const [isView, setIsView]=useState<boolean>(modulePermission?.find((permision:any)=>permision==="1" ? true:false))
  const [isAdd, setIsAdd]=useState<boolean>(modulePermission?.find((permision:any)=>permision==="2" ? true:false))
  const [isEdit, setIsEdit]=useState<boolean>(modulePermission?.find((permision:any)=>permision==="3" ? true:false))
  const [isDelete, setIsDelete]=useState<boolean>(modulePermission?.find((permision:any)=>permision==="4" ? true:false))
  const [isModuleId, setIsModuleId]=useState<boolean>(modulePermission?.find((permision:any)=>permision==="1" ? true:false))
  const [isModuleCheck, setIsmoduleCheck]=useState(modulePermission?.find((permision:any)=>permision==="1" ? true:false));
  const [selPermissions, setSelPermissions] = useState<any>();

  useEffect(()=>{
    setIsView(modulePermission?.find((permision:any)=>permision=="1" ? true:false))
    setIsAdd(modulePermission?.find((permision:any)=>permision=="2" ? true:false))
    setIsEdit(modulePermission?.find((permision:any)=>permision=="3" ? true:false))
    setIsDelete(modulePermission?.find((permision:any)=>permision=="4" ? true:false))
    setIsModuleId(modulePermission?.find((permision:any)=>permision=="1" ? true:false))
    setIsmoduleCheck(modulePermission?.find((permision:any)=>permision==="1" ? false:true));
    
  
   },[modulePermission])
   
  const handleCheck=(permision:any)=>{
      switch(permision) {
          case 1: //View
            setIsView(true);
            break;
          case 2: //Add
            setIsAdd(true);
            break;
          case 3: //Edit
            setIsEdit(true);
            break;
          case 4 : //Delete
            setIsDelete(true);
            break;
      }
  }

const updatePermissions=()=>{
    let permissions = [];
    if(isView){
        permissions.push(1)
    }
    if(isAdd){
        permissions.push(2)
    }
    if(isEdit){
        permissions.push(3)
    }
    if(isDelete){
        permissions.push(4)
    }
    //console.log(permissions,"44444444444444")
    //handleChangePermision(permissions.join(","));
    handleChangeModule(module,permissions.join(","));
}

  const modulesCheck=()=>{
        setIsmoduleCheck(!isModuleCheck)
        
        //handleChangeModule(module)
  }
  useEffect(() => {
    getModulePermission();
    updatePermissions();
   // setModuleDetails(module)
    
  }, [isView, isAdd, isEdit, isDelete]);
    return (
        <>
          <td>
            <Form.Check
              style={styles.checkmargin}
              type="checkbox"
              onChange={(e) => modulesCheck()}
              defaultChecked={isModuleId}
            />
          </td>
          <td className="text-left">{module?.moduleName}</td>                            
              <td >
              <Form.Check
              style={styles.checkmargin}
              type="checkbox"
              //disabled={isModuleCheck}
              onChange={(e) => handleCheck(1)}
              defaultChecked={isView}
            />
          </td>

          <td>
          <Form.Check
              style={styles.checkmargin}
              type="checkbox"
              //disabled={isModuleCheck}
              onChange={(e) => handleCheck(2)}
              defaultChecked={isAdd}
            />
          </td>
          <td>
          <Form.Check
              style={styles.checkmargin}
              type="checkbox"
              //disabled={isModuleCheck}
              onChange={(e) => handleCheck(3)}
              defaultChecked={isEdit}
            />
          </td>
          <td>
          <Form.Check
              style={styles.checkmargin}
              type="checkbox"
             // disabled={isModuleCheck}
              onChange={(e) => handleCheck(4)}
              defaultChecked={isDelete}
            />
          </td>
        </>
      );
}
const styles: any = {
    checkmargin: {
        marginLeft: "15px",
      },
}
export default ModuleRow